import React from 'react'
import Heading from 'components/shared/Heading'
import OrderNavigation from 'components/shared/OrderNavigation'
import PurchasableProductCard from 'components/shared/PurchasableProductCard'
import { PRODUCT_CATEGORIES } from 'lib/productHelpers'
import './index.scss'

const ChooseProducts = ({
  webOrder,
  productSelection,
  productSelectionReducer,
  goToNextStep,
  goToPreviousStep,
  productAvailability,
}) => {
  const addProduct = (product) => {
    productSelectionReducer({ type: 'addProduct', product })
  }

  const removeProduct = (product) => {
    productSelectionReducer({ type: 'removeProduct', product })
  }

  const updateProduct = (product) => {
    productSelectionReducer({ type: 'updateProduct', product })
  }

  const bundleProducts = productSelection.bundleId
    ? webOrder.bundles.edges
        .find((e) => e.node.id === productSelection.bundleId)
        .node.products.edges.map((e) => e.node)
    : []

  const productInBundle = (product) => {
    return bundleProducts.find((p) => p.__typename === product.__typename)
  }

  const productInOrder = (product) => {
    return productSelection.products.find(
      (p) => p.__typename === product.__typename
    )
  }

  const availableProducts = webOrder.availableProducts.edges.map((e) => e.node)
  const recommendedProducts =
    availableProducts && availableProducts.length
      ? availableProducts.filter(({ isRecommended }) => isRecommended === true)
      : []

  return (
    <div className="new-order choose-products">
      <Heading level={2}>{productSelection.bundleId ? 'Velg tilleggsprodukter' : 'Velg produkter'}</Heading>

      <div className="products">
        {recommendedProducts.length > 0 && (
          <div className="product-category">
            <Heading level={3}>Anbefalte produkter</Heading>
            {recommendedProducts.map((product) => (
              <PurchasableProductCard
                key={product.id}
                product={product}
                productInBundle={productInBundle}
                productInOrder={productInOrder}
                addProduct={addProduct}
                updateProduct={updateProduct}
                removeProduct={removeProduct}
                productAvailability={productAvailability}
                webOrder={webOrder}
              />
            ))}
          </div>
        )}

        {Object.keys(PRODUCT_CATEGORIES).map((category, i) => {
          const productsInCategory = availableProducts.filter(
            (product) => product.category === category
          )
          if (productsInCategory.length > 0) {
            return (
              <div className="product-category" key={i}>
                <Heading level={3}>{PRODUCT_CATEGORIES[category]}</Heading>
                {productsInCategory.map((product) => (
                  <PurchasableProductCard
                    key={product.id}
                    product={product}
                    productInBundle={productInBundle}
                    productInOrder={productInOrder}
                    addProduct={addProduct}
                    updateProduct={updateProduct}
                    removeProduct={removeProduct}
                    productAvailability={productAvailability}
                    webOrder={webOrder}
                  />
                ))}
              </div>
            )
          } else {
            return null
          }
        })}
      </div>

      <OrderNavigation
        onBack={goToPreviousStep}
        onNext={goToNextStep}
        nextButtonProps={{
          disabled: productSelection.products.length === 0,
        }}
      />
    </div>
  )
}

export default ChooseProducts
